// extracted by mini-css-extract-plugin
export default {"label":"filter_label__k4Jq2","input":"filter_input__vjfXX"};